module.exports = __webpack_public_path__ + "img/wolf_6.9948f2c8.jpg";